import classNames from 'classnames'

import { useDragAndDrop } from '@/app/hooks'
import { Icon } from '@/shared'
import { type ISwapSequencs } from '@App/types/common'
import { EIcons } from '@App/types/iconType'
import { type IChildServiceDec } from '@App/types/servicesTypes'

import style from './Services.module.scss'

interface IProps {
    services: IChildServiceDec[]
    parentName: string
    parentId: string
    isDraggable: boolean
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    onSwapServices: (dto: ISwapSequencs) => void
}

export const Services = (props: IProps) => {
    const { services, parentName, parentId, isDraggable, onSetTranferSevice, onSwapServices } = props

    const {
        currentItem,
        highlited,
        setHighlited,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler
    } = useDragAndDrop()

    const onDropHandler = (e: any, item: IChildServiceDec) => {
        e.preventDefault()
        setHighlited(null)
        if (currentItem && currentItem.id !== item.id) {
            onSwapServices({ srcId: currentItem.id, destId: item.id })
        }
    }

    return (
        <div className={style.container}>
            <div className={style.header}>
                <span>Услуги от &quot;{parentName}&ldquo;</span>
            </div>
            {services.map((service) => {
                const { id, name, code } = service
                const onTranferService = () => {
                    onSetTranferSevice({ ...service, parentId })
                }

                const containerCn = classNames(style.serviceItem, highlited === id && style.highlitedContainer)

                return (
                    <div
                        key={id}
                        className={containerCn}
                        onDragStart={(e: any) => onDragStartHandler(e, service)}
                        onDragLeave={(e: any) => onDragLeaveHandler(e, id)}
                        onDragEnd={onDragEndHandler}
                        onDragOver={(e: any) => onDragOverHandler(e, id)}
                        onDrop={(e: any) => onDropHandler(e, service)}
                        draggable={isDraggable}
                    >
                        <div className={style.code}>
                            <div className={style.iconWrapper} onClick={onTranferService}>
                                <Icon iconName={EIcons.AROW} color='#007dee' />
                            </div>
                            <span>{code}</span>
                        </div>
                        <div className={style.name}>
                            <span>{name}</span>
                        </div>
                        {/* <div className={style.cost}>{cost && <span>{common.formatCurrancy(cost)}</span>}</div> */}
                    </div>
                )
            })}
        </div>
    )
}
